import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="306"
      height="723"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 306 723"
      xmlSpace="preserve"
      className='clickable'
    >
      <g
        fill='rgba(0,0,0,0)'
        className='object-glow'
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-1032.5 -1117.5)"
      >
        <path
          fill="none"
          strokeWidth="5"
          d="M1176 1141c63.25 9.75 134 18 134 18s2.25 3.25 2 10-2 11-2 11l-138-19-118-20s-2.5-4.75-1-10 4-11 4-11 55.75 11.25 119 21z"
          opacity="0.996"
        ></path>
        <path
          fill="#000"
          fillRule="nonzero"
          strokeWidth="5"
          d="M1122 1124l-5 36 9 2 5-37z"
          opacity="0.996"
        ></path>
        <path
          fill="#000"
          fillRule="nonzero"
          strokeWidth="5"
          d="M1246 1142l-5 36 9 2 5-37z"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="7"
          d="M1182.98 1135s-4.96 7.1-6.54 15.89c-1.57 8.79 1.54 18.11 1.54 18.11l36 5 4-34z"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1181 1151.34l12 1.66"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1203 1155.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1163 1149.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1150 1147.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1138 1145.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1103 1139.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1114 1141.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1127 1143.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1091 1137.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1080 1135.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1069 1133.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1191.04 1152.97a3.502 3.502 0 013.99-2.93c1.91.29 3.22 2.08 2.93 3.99a3.502 3.502 0 01-3.99 2.93 3.502 3.502 0 01-2.93-3.99z"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1220 1157.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5z"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1277 1154s4.75 2.25 4 11-7 10-7 10"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1056 1142s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1311 1197s4.75 8.25 7 16 3 17 3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1314 1213s4.75 8.25 7 16 3 17 3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1311 1224s4.75 8.25 7 16 3 17 3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1310 1237s4.75 8.25 7 16 3 17 3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1310 1251s4.75 8.25 7 16 3 17 3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1312 1273s4.75 8.25 7 16 3 17 3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1310 1286s4.75 8.25 7 16 3 17 3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1313 1303s4.75 8.25 7 16 3 17 3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1315 1319s4.75 8.25 7 16 3 17 3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1316 1334s4.75 8.25 7 16 3 17 3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1318 1346s4.75 8.25 7 16 3 17 3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1319 1363s4.75 8.25 7 16 3 17 3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1320 1379s4.75 8.25 7 16 3 17 3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1320 1395s4.75 8.25 7 16 3 17 3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1320 1411s4.75 8.25 7 16 3 17 3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1320 1428s6.75 13.25 9 21"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1319 1443s3.75 6.25 6 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1316 1455s1.75 2.25 4 10"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1312 1578c2.25 7.75 5 20 5 20"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1301 1582s4.75 8.25 7 16 3 17 3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1304 1575s4.75 8.25 7 16 3 17 3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1298 1597s4.75 8.25 7 16 3 17 3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1309 1181s4.75 8.25 7 16 3 17 3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1056 1155s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1054 1172s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1053 1184s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1052 1196s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1053 1207s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1052 1223s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1051 1239s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1050 1255s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1049 1268s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1050 1281s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1052 1294s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1053 1305s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1054 1316s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1056 1328s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1058 1340s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1061 1351s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1061 1363s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1063 1374s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1064 1385s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1064 1401s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1065 1414s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1066 1428s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1067 1438s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1071 1444s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1073 1452s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1072 1466s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1072 1479s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1069 1495s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1065 1508s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1065 1517s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1068 1525s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1072 1529s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1073 1541s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1070 1561s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1071 1575s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1070 1592s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1072 1605s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1073 1616s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1074 1628s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1076 1642s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1080 1651s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1081 1663s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1082 1674s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1083 1687s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1085 1697s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1089 1705s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1089 1715s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1090 1726s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1090 1737s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1091 1749s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1092 1758s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1092 1771s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1092 1784s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1091 1798s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1094 1806s-4.75 8.25-7 16-3 17-3 17"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1057 1151s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1308 1189s3.25 7.75 7 13l10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1311 1204s3.25 7.75 7 13l10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1312 1217s3.25 7.75 7 13l10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1312 1232s3.25 7.75 7 13l10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1310 1245s3.25 7.75 7 13l10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1311 1261s3.25 7.75 7 13l10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1310 1276s3.25 7.75 7 13l10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1309 1290s3.25 7.75 7 13l10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1311 1305s3.25 7.75 7 13l10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1309 1312s3.25 7.75 7 13l10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1313 1324s3.25 7.75 7 13l10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1314 1337s3.25 7.75 7 13l10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1315 1348s3.25 7.75 7 13l10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1316 1365s3.25 7.75 7 13l10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1320 1387s3.25 7.75 7 13l10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1320 1405s3.25 7.75 7 13l10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1320 1421s3.25 7.75 7 13 5 9 5 9"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1319 1436s4.25 9.75 8 15"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1317 1449s2.25 5.75 6 11"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1315 1461s2 2 3 8"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1307 1577c1.35 1.9 3.69 4.64 6.11 7.37 4.3 4.83 8.89 9.63 8.89 9.63"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1301 1576s3.25 7.75 7 13l10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1298 1584s3.25 7.75 7 13l10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1298.96 1589.95s2.14 8.13 5.12 13.85c2.99 5.72 7.96 15.25 7.96 15.25"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1295.92 1601s2.14 8.13 5.12 13.85c2.99 5.72 7.96 15.25 7.96 15.25"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1056 1163s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1056 1178s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1053 1189s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1053 1199s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1053 1215s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1053 1231s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1052 1244s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1051 1262s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1051 1275s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1052 1287s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1054 1299s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1056 1309s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1056 1322s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1058 1335s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1061 1345s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1063 1356s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1064 1367s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1065 1379s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1065 1393s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1066 1407s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1067 1420s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1067 1434s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1070 1441s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1073 1449s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1073 1459s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1073 1472s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1071 1488s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1068 1502s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1068 1511s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1069 1518s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1071 1526s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1072 1536s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1071 1553s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1070 1568s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1070 1585s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1072 1596s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1074 1606s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1075 1620s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1076 1632s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1079 1644s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1081 1656s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1081 1669s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1082 1682s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1083 1693s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1086 1705s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1088 1722s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1089 1734s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1090 1745s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1089 1770s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1091 1780s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1093 1791s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1096 1797s-3.25 7.75-7 13l-10 14"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1181 1173s2 11.75 1 31-5 46-5 46"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1196 1175s.75 14.25-1 31-6 36-6 36"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1080 1221s32.5 8.25 56 24 39 42 39 42"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1090 1248s26.75-2.75 47 9 34 38 34 38"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1086 1160s15.75 7.5 31 16 30 18 30 18"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1110 1165s21.75 13.25 37 22 24 13 24 13"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1135 1203s10.75 9.5 17 17 8 13 8 13"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1184 1284s9.5 5.5 17 20 13 38 13 38-11.5-15.5-19-30-11-28-11-28z"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1138 1634s8-2.75 14-7 10-10 10-10"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1216 1555s16.5 15 34 16 36-12 36-12"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1218 1590s10 11.75 21 18 23 7 23 7"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1217 1591s14.25 25 32 32 42-5 42-5"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1220 1600s13.5 26.5 29 34 33-4 33-4"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1144 1718s11.5-8 17-18 5-22 5-22"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1109 1742s12.5 12 27 5 31-33 31-33"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1124 1751c5 10 14 7.75 24 3s16-22 16-22"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1120 1767s11 8 20 8 16-8 16-8"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1164 1753s-4.25 6-3 16c2 16-2 24-2 24"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1092 1813s2 21 33 12c19.23-5.58 47.16-.73 48-7 2-15-4.7-41.14-4-62 1.8-53.72 2.79-89.89-3-129-4-27-6-47-5-69 .62-13.69 5-16.25 7-25s1.1-12.14 1.37-14.54c.26-2.4 2.06-5.41 2.59-8.44.71-4.05 1.07-9.57 1.04-16.02-.17-34.43-4.31-87.48-2.39-115.98.62-9.18 3.22-18.04 4.34-20.25 1.12-2.21 3.87-8.25 5.95-7.32 2.38 1.06 2.92 3.18 3.37 5.92.56 3.35 1.11 7.81 2.33 16.28 2.32 16.11 5.59 40.54 7.4 66.35.89 12.77.85 26.34 1.49 38.6.31 5.84.62 12.87 1.73 17.89.4 1.78 1.31 2.27 1.78 4.51 1.9 9.07 3.45 20.62 4 23 3 13 7 10 9 26 1.09 8.74.21 18.48 1.22 30.37 2.12 24.97 3.78 50.63 3.78 50.63s14 34 40 32c18.09-1.39 32-23 32-23s3-7 5-14 3-14 3-14"
          opacity="1"
        ></path>
        <path
          fill="none"
          strokeWidth="3"
          d="M1312 1376s-8 14.75-18 25-22 16-22 16"
          opacity="0.996"
        ></path>
        <path
          fill="none"
          strokeWidth="1"
          d="M1212 1545s6.65 6.43 9 8c3 2 13 6 13 6s-5.75-6.25-11-10-11-4-11-4z"
          opacity="0.996"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;